import { connect } from "react-redux";
import CampaignView from "./CampaignView";
import { bindActionCreators } from "redux";
import {userRequestById, approval, backToModificationRequest, backToModificationResponse} from "../../../services/redux/userHelpdesk/action";
import { getCampaignData } from 'services/redux/brandActivtion/adsCampaign/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    requestByIdDetails : state.UserHelpdesk.requestByIdDetails,
    approvedResponse : state.UserHelpdesk.approvedResponse,
    modificationRequest : state.UserHelpdesk.modificationRequest,
    modificationResponse : state.UserHelpdesk.modificationResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    getCampaignListing: state.campaignReducer.getCampaignListing,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userRequestById,
        approval,
        documentUploadUrlPublic,
        backToModificationRequest,
        backToModificationResponse,
        getCampaignData
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CampaignView);